import React, { createContext, useState, useContext } from 'react';

// Create the context
const DogContext = createContext();

// Create a provider component
export const DogProvider = ({ children }) => {
  const [isDogVisible, setIsDogVisible] = useState(false);

  const showDog = () => setIsDogVisible(true);
  const hideDog = () => setIsDogVisible(false);

  return (
    <DogContext.Provider value={{ 
      isDogVisible, 
      showDog, 
      hideDog 
    }}>
      {children}
    </DogContext.Provider>
  );
};

// Custom hook to use the dog context
export const useDog = () => useContext(DogContext); 